"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationCallCodeFormController = void 0;
var React = _interopRequireWildcard(require("react"));
var _ContentLayout = require("../ContentLayout");
var _ConfirmationCallCodeForm = require("../ConfirmationCallCodeForm");
var _validation = require("../../utils/validation");
var _requestStatus = require("../../types/requestStatus");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PIN_INPUT_LENGTH = 4;
const ConfirmationCallCodeFormController = _ref => {
  let {
    hasCodeError,
    sendValidationCodeStatus,
    codeError: codeErrorRaw,
    isSubmitting,
    codeTimeout,
    source,
    onResendCode,
    onVerify,
    onCodeCleared
  } = _ref;
  const prevSendValidationCodeStatus = React.useRef(sendValidationCodeStatus);
  const [lastAttemptTimestamp, setLastAttemptTimestamp] = React.useState(new Date().getTime());
  const [isChanged, setChanged] = React.useState(false);
  const [code, setCode] = React.useState([]);
  const [isCodeTimeoutFinished, setResendCodeAvailable] = React.useState(false);
  const isCodeInvalid = !isChanged && hasCodeError;
  const isResendCodeAvailable = !isSubmitting && isCodeTimeoutFinished;
  const codeError = !isChanged ? codeErrorRaw : '';
  const handleCodeTimeoutExpired = React.useCallback(() => {
    setResendCodeAvailable(true);
  }, []);
  const handleChangeCode = React.useCallback(value => {
    const newValue = value.reduce((acc, item, index) => {
      acc[index] = item.replace(/\D/gi, '').slice(0, 1);
      return acc;
    }, []).splice(0, PIN_INPUT_LENGTH);
    setChanged(true);
    setCode(newValue);
  }, []);
  const handleSubmit = React.useCallback(() => {
    const normalizedCode = code.join('');
    if (!(0, _validation.isValidCode)(normalizedCode)) {
      return;
    }
    onVerify(normalizedCode);
    setChanged(false);
  }, [code, onVerify]);
  React.useEffect(() => {
    if (prevSendValidationCodeStatus.current !== sendValidationCodeStatus) {
      if (sendValidationCodeStatus === _requestStatus.ERequestStatus.Failed) {
        setLastAttemptTimestamp(null);
      } else if (sendValidationCodeStatus === _requestStatus.ERequestStatus.Succeed) {
        setLastAttemptTimestamp(new Date().getTime());
      }
      setResendCodeAvailable(false);
    }
    prevSendValidationCodeStatus.current = sendValidationCodeStatus;
  }, [sendValidationCodeStatus]);
  const handleResendClick = React.useCallback(() => onResendCode(source), [source, onResendCode]);
  const handleClearClick = React.useCallback(() => {
    if (onCodeCleared) {
      onCodeCleared(source);
    }
  }, [source, onCodeCleared]);
  return /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement(_ConfirmationCallCodeForm.ConfirmationCallCodeForm, {
    code: code,
    codeLength: PIN_INPUT_LENGTH,
    codeError: codeError,
    submitButtonText: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
    isCodeInvalid: isCodeInvalid,
    isSubmitting: isSubmitting,
    isResendCodeAvailable: isResendCodeAvailable,
    codeTimeout: codeTimeout,
    codeSendTimestamp: lastAttemptTimestamp,
    onCodeTimeoutExpired: handleCodeTimeoutExpired,
    onCodeChange: handleChangeCode,
    onResendCode: handleResendClick,
    onSubmit: handleSubmit,
    onCodeCleared: handleClearClick
  }));
};
exports.ConfirmationCallCodeFormController = ConfirmationCallCodeFormController;
ConfirmationCallCodeFormController.displayName = 'ConfirmationCallCodeFormController';